var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.583 4.19 11.033.196 9.865 1.819l3.033 2.183h-7.8l3.033-2.183L6.962.196 1.412 4.19l-.415.3v.512l.002 10v1h16V4.489l-.416-.3zM2.997 6.002h12.002v8h-12l-.002-8zM7 10h4V8H7v2z",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmountIcon);
export default __webpack_public_path__ + "static/media/amount-icon.a56ebb487f7e31824e54c3e0a201d22c.svg";
export { ForwardRef as ReactComponent };